// CMS ACCESSUnalignmentReasonCS, the vocabulary WF24 validates and writes into
// care_period.disenrollment_reason. Shared so the withdrawal modal can label a
// reason WF24 already recorded without minting a third copy of these codes.
import { CMS_UNALIGN_REASONS } from '../../../scripts/withdrawal-reason.mjs';

export interface UnalignReason {
  value: string;
  label: string;
}

export const UNALIGN_REASONS: UnalignReason[] = CMS_UNALIGN_REASONS.map(
  (r) => ({ value: r.code, label: r.label }),
);
